import { render, staticRenderFns } from "./openCard.vue?vue&type=template&id=062f7ec5&scoped=true"
import script from "./openCard.vue?vue&type=script&lang=js"
export * from "./openCard.vue?vue&type=script&lang=js"
import style0 from "./openCard.vue?vue&type=style&index=0&id=062f7ec5&prod&lang=css"
import style1 from "./openCard.vue?vue&type=style&index=1&id=062f7ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f7ec5",
  null
  
)

export default component.exports